import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { FOOTER_LINKS, BRAND, DEMO_URL } from '../../data/dgpt';
import { CtaButton } from '../ui/CtaButton';
import { DgptLogo } from './DgptLogo';
const year = new Date().getFullYear();
export function DgptFooter() {
  return <footer className="border-t border-hairline bg-surface pb-24 sm:pb-0" data-id="element-34" data-mp="wttvxadksqpk">
      <div className="mx-auto flex w-full max-w-[1320px] flex-col gap-10 px-4 py-12 sm:px-6 lg:flex-row lg:items-start lg:justify-between lg:px-8" data-id="element-35" data-mp="wvwljtatghtr">
        <div className="flex flex-col gap-3" data-id="element-36" data-mp="n3quclse24fm">
          <DgptLogo data-id="element-37" data-mp="n2pfe6894xsm" />
          <p className="text-sm text-text-secondary" data-id="element-38" data-mp="i4xggs96wbex">{BRAND.tagline}</p>
        </div>

        <nav aria-label="Footer" data-id="element-39" data-mp="i2uoi2oh887k">
          <ul className="flex flex-wrap gap-x-7 gap-y-3" data-id="element-40" data-mp="d6cpljftv435">
            {FOOTER_LINKS.map(link => {
            const external = link.href.startsWith('http');
            return <li key={link.label} data-id="element-41" data-mp="45elz29awyl3">
                  <a href={link.href} {...external ? {
                target: '_blank',
                rel: 'noopener noreferrer'
              } : {}} className="text-xs font-medium uppercase tracking-[0.14em] text-text-secondary transition-colors hover:text-text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime focus-visible:ring-offset-4 focus-visible:ring-offset-surface" data-id="element-42" data-mp="46h8kxzlcev7">
                    {link.label}
                  </a>
                </li>;
          })}
          </ul>
        </nav>

        <CtaButton href={DEMO_URL} event="section_book_demo_click" className="w-full sm:w-fit" data-id="element-43" data-mp="3pytil1bbi654">
          Book a Demo
          <ArrowRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-44" data-mp="3by0lc8tmswyb" />
        </CtaButton>
      </div>
      <div className="mx-auto w-full max-w-[1320px] border-t border-hairline-soft px-4 py-6 text-xs text-text-tertiary sm:px-6 lg:px-8" data-id="element-45" data-mp="3gwk82bg1ucrq">
        © {year}{' '}
        <a href="https://www.startupfuel.com" target="_blank" rel="noopener noreferrer" className="font-medium text-text-secondary underline-offset-4 transition-colors hover:text-text-primary hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime focus-visible:ring-offset-2 focus-visible:ring-offset-surface" data-id="element-46" data-mp="25igj5jobjetj">
          StartupFuel
        </a>
        . DiligenceGPT™ by StartupFuel.
      </div>
    </footer>;
}